import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  StyledWrapper,
  StyledElementsList,
  StyledArrowRight,
  StyledArrowLeft,
  BoxGeneral,
  StyledTabs
} from './style';

import ButtonActions from './ButtonActions';

class MenuTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      posX: 0,
      menuWithScroll: false
    };
  }

  componentDidMount() {
    const menuTabs = document.getElementById('menuTabs');
    const widthMenuTabs = menuTabs.clientWidth;
    if (widthMenuTabs > 1040) {
      this.setState({
        menuWithScroll: true
      });
    }
  }

  scrollMobile = x => {
    const menuMobile = document.querySelector('#menuTabsMobile');
    menuMobile.scrollLeft = x;
  };

  render() {
    const {
      className,
      color,
      dataMenu,
      clickHandler,
      currentPath,
      textButtonAction
    } = this.props;

    const { posX, isOpen, menuWithScroll } = this.state;

    return (
      <StyledWrapper menuWithScroll={menuWithScroll}>
        <BoxGeneral
          className={`item ${className}`}
          id="menuTabsMobile"
          menuWithScroll={menuWithScroll}
        >
          <ButtonActions
            selected={isOpen}
            text={textButtonAction}
            menuWithScroll={menuWithScroll}
          />
          <StyledArrowLeft color={color} />
          <div id="menuTabs">
            <StyledTabs
              selected={isOpen}
              posX={posX}
              menuWithScroll={menuWithScroll}
            >
              {dataMenu.map(item => (
                <StyledElementsList
                  key={item.id}
                  id={item.id}
                  active={item.route === currentPath}
                  clicked={() => {
                    clickHandler(item.route);
                  }}
                  menuWithScroll={menuWithScroll}
                >
                  {item.name}
                </StyledElementsList>
              ))}
            </StyledTabs>
            <StyledArrowRight color={color} />
          </div>
        </BoxGeneral>
      </StyledWrapper>
    );
  }
}

MenuTabs.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  dataMenu: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string
    })
  ),
  clickHandler: PropTypes.func,
  textButtonAction: PropTypes.string
};

MenuTabs.defaultProps = {
  color: 'grayDark',
  clickHandler: undefined,
  textButtonAction: 'Mis cosas'
};

export default MenuTabs;
